import { ManagementLevel } from '../../signup-data/ManagementLevelOption';
export let DataStateKey;

(function (DataStateKey) {
  DataStateKey["value"] = "value";
  DataStateKey["prefilled"] = "prefilled";
  DataStateKey["completed"] = "completed";
  DataStateKey["skipped"] = "skipped";
  DataStateKey["validation"] = "validation";
  DataStateKey["errorMessage"] = "errorMessage";
})(DataStateKey || (DataStateKey = {}));

export const SeniorityLevel = {
  [ManagementLevel.BoardMember]: 'Board Member',
  [ManagementLevel.Owner]: 'Owner',
  [ManagementLevel.ExecutiveTeam]: 'Executive Team',
  [ManagementLevel.VicePresidentDirector]: 'Vice President/Director',
  [ManagementLevel.Manager]: 'Manager',
  [ManagementLevel.Employee]: 'Employee',
  [ManagementLevel.Freelancer]: 'Freelancer',
  [ManagementLevel.StudentIntern]: 'Student/Intern',
  Other: 'Other'
};